import { Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { ApiOffer } from '@tytapp/api';

@Component({
  selector: 'tyt-offer-inline-pricing',
  templateUrl: './offer-inline-pricing.component.html',
  styleUrls: ['./offer-inline-pricing.component.scss']
})
export class OfferInlinePricingComponent implements OnInit {

  @Input()
  offer: ApiOffer = null;

  @Input()
  isOther: boolean = false;

  /**
   * Specify the price to show on offers with sponsorship_count > 0
   * Should represent the price of a subsidized membership
   */
  @Input()
  subsidizedPrice : number = 1.99;

  @HostBinding('class.one-time')
  get isOneTime() {
    if (!this.offer)
      return false;
    return this.offer.period === 'one_time';
  }
  
  get priceIsOverridden() {
    return this.offer.membership_product 
      && this.offer.price !== this.offer.membership_product.price 
      && this.offer.price < this.offer.membership_product.price;
  }

  constructor(
    private elementRef : ElementRef
  ) {
  }

  element : HTMLElement;

  ngOnInit() {
    this.element = this.elementRef.nativeElement;
  }

  frequencySuffixForPeriod(period : string) {
    if (period === 'monthly')
      return '/Month';
    else if (period === 'annually')
      return '/Year';
    return '';
  }

  buttonClick(event) {
    event.stopPropagation();
    event.preventDefault();

    if(this.element) {
      const button: HTMLButtonElement = this.element.querySelector('tyt-tooltip-button button');
      if(button) {
        button.click();
      }
    }
  }

}
